// extracted by mini-css-extract-plugin
module.exports = {"störer":"St_rer_st_rer__M1KYi","text":"St_rer_text__AiPJr","shape":"St_rer_shape__pt3_9"};